import Type14 from '../Type14';
import Type17 from '../Type17';
import Type29 from '../Type29';
import Type30 from '../Type30';
import Type31 from '../Type31';
import Type35 from '../Type35';
import Type36 from '../Type36';
import Type37 from '../Type37';
import Type38 from '../Type38';
import Type39 from '../Type39';
import Type40 from '../Type40';
import Type41 from '../Type41';
import Type71 from '../Type71';
import Type72 from '../Type72';
import Type73 from '../Type73';
import Type74 from '../Type74';
import Type75 from '../Type75';
import Type77 from '../Type77';
import Type78 from '../Type78';
import Type79 from '../Type79';
import Type80 from '../Type80';
import Type100 from '../Type100';
import Type106 from '../Type106';
import Type132 from '../Type132';

const routes = [
  {
    path: '/olympic/admin/classes/5/types/type29',
    name: 'Type 1 (RD) - Type 29',

    component: Type29,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type30',
    name: 'Type 2 (RD) - Type 30',

    component: Type30,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type44',
  //   name: 'Type 3 (RD) - Type 44',
  //
  //   component: Type44,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type31',
    name: 'Type 3 (RD) - Type 31',

    component: Type31,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type45',
  //   name: 'Type 4 (RD) - Type 45',
  //
  //   component: Type45,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type132',
    name: 'Type 4 (RD) - Type 132',

    component: Type132,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type46',
  //   name: 'Type 5 (RD) - Type 46',
  //
  //   component: Type46,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  // {
  //   path: '/olympic/admin/classes/5/types/type47',
  //   name: 'Type 6 (RD) - Type 47',
  //
  //   component: Type47,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type35',
    name: 'Type 7 (RD) - Type 35',

    component: Type35,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type36',
    name: 'Type 8 (RD) - Type 36',

    component: Type36,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type37',
    name: 'Type 9 (RD) - Type 37',

    component: Type37,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type38',
    name: 'Type 10 (RD) - Type 38',

    component: Type38,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type39',
    name: 'Type 11 (RD) - Type 39',

    component: Type39,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type40',
    name: 'Type 12 (RD) - Type 40',

    component: Type40,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type54',
  //   name: 'Type 13 (RD) - Type 54',
  //
  //   component: Type54,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type41',
    name: 'Type 13 (RD) - Type 41',

    component: Type41,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type55',
  //   name: 'Type 14 (RD) - Type 55',
  //
  //   component: Type55,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type17',
    name: 'Type 15 (RD) - Type 17',

    component: Type17,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type57',
  //   name: 'Type 16 (RD) - Type 57',
  //
  //   component: Type57,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type14',
    name: 'Type 16 (RD) - Type 14',

    component: Type14,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type71',
    name: 'Type 17 (RD) - Type 71',

    component: Type71,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type72',
    name: 'Type 18 (RD) - Type 72',

    component: Type72,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type73',
    name: 'Type 19 (RD) - Type 73',

    component: Type73,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type74',
    name: 'Type 20 (RD) - Type 74',

    component: Type74,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type75',
    name: 'Type 21 (RD) - Type 75',

    component: Type75,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type100',
    name: 'Type 22 (RD) - Type 100',

    component: Type100,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type77',
    name: 'Type 23 (RD) - Type 77',

    component: Type77,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type78',
    name: 'Type 24 (RD) - Type 78',

    component: Type78,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type79',
    name: 'Type 25 (RD) - Type 79',

    component: Type79,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/5/types/type104',
  //   name: 'Type 26 (RD) - Type 104',
  //
  //   component: Type104,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/5/types/type80',
    name: 'Type 26 (RD) - Type 80',

    component: Type80,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type37',
    name: 'Type 27 (RD) - Type 37',

    component: Type37,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/5/types/type106',
    name: 'Type 28 (RD) - Type 106',

    component: Type106,
    layout: '/lms',

    exact: true,
  },
];

export default routes;
